// extracted by mini-css-extract-plugin
var _1 = "CustomerTransferApprovalTable-module__action-button";
var _2 = "CustomerTransferApprovalTable-module__action-button-container";
var _3 = "CustomerTransferApprovalTable-module__approve";
var _4 = "CustomerTransferApprovalTable-module__gold-row";
var _5 = "CustomerTransferApprovalTable-module__reject";
export { _1 as "action-button", _2 as "action-button-container", _3 as "approve", _4 as "gold-row", _5 as "reject" }
